module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-03@2x.edc314e.jpg";